@if (item) {
<div>
    <div class="flex left">
        <!-- image -->
        <a style="min-width: 7rem; height: max-content;"
           [ngClass]="item.isGiftcard ? 'ratio-3-2' : 'ratio-3-4'"
           [class.giftcardItemImage]="item.isGiftcard"
           [routerLink]="product?.data?.url">
            <img class="rf"
                 [options]="item.isGiftcard ? {} : {fitIn: true}"
                 [image]="image">
        </a>
        <!-- right side -->
        <div class="flex-grow flex-column flex-justify-between m-t-1-s m-l-3 m-l-4-s">
            <div class="flex flex-justify-between m-b-2 m-b-3-s">
                <div class="flex flex-column">
                    @if(item.isFreeGift) {
                    <p class="s2 col-56 w-12">{{'Free Gift' | translate}}</p>
                    }
                    <!-- name -->
                    <a class="p1 m-r-2"
                       [routerLink]="product?.data?.url">{{product?.data?.name}}</a>
                    @if (localProduct.inStockEstimationMessage && !product?.isConfigurable &&
                    localProduct.backOrderOnly)
                    {
                    <p class="col-11 p-l-2 p-r-2 bg-col-4 b-a b-col-42 m-t-1 center"
                       sizeClass="'XL': p2, 'MS': p3"
                       [style.maxWidth]="'fit-content'"
                       [style.paddingTop.px]="6"
                       [style.paddingBottom.px]="6">
                        {{'Estimated in stock' | translate}} {{localProduct.inStockEstimationMessage}}
                    </p>
                    }
                </div>
                <!-- price-->
                <div class="right flex-column-s flex-column-reverse-s flex-justify-end-s s2">
                    @if (rowOrgPrice) {
                    <price class="line-through price col-12 m-r-2 m-r-0-s"
                           precision="2"
                           [value]="rowOrgPrice"></price>
                    }
                    <price precision="2"
                           class="price"
                           [value]="item.isFreeGift ? item.data.rowPrice : rowPrice"
                           [useFreeLabel]="item.isFreeGift"></price>
                </div>
            </div>
            @if (product && !item.isGiftcard) {
            <div class="col-12 c1 inline-flex flex-wrap">
                <!-- configurable options -->
                @for (option of item.configurableOptions; track $index; let isFirst = $first) {
                <span>
                    @if (!isFirst) {
                    <span class="p2">&nbsp;|&nbsp;</span>
                    }
                    {{(option.value | optionLabel : option.code)}}
                </span>
                }
                <!-- custom options -->
                @for (option of item.customOptions; track $index; let isFirst = $first) {
                <span>
                    @if (option.labels.length) {
                    <p>
                        @for (label of option.labels; track $index) {
                        @if (!isFirst) {
                        <span class="p2">&nbsp;|&nbsp;</span>
                        }
                        {{label}} }
                    </p>
                    }
                </span>
                }
            </div>
            }
            <!-- Gift card personalised message-->
            @if (item.giftCardPersonalisedMessage) {
            <p class="col-12 c1 left">
                <span class="uppercase">{{'Message' | translate}}</span>:&nbsp;{{item.giftCardPersonalisedMessage}}
            </p>
            }
            <!-- stock info -->
            @if (item.warning) {
            <p class="p2 col-2">{{ item.warning | translate }}</p>
            }
            <div class="m-t-1 m-b-1 m-b-0-s">
                <!-- qty / remove -->
                <div class="w-4 flex flex-middle pos-relative">
                    @if (!item.isGiftcard && !item.isVirtual && !item.isFree) {
                    <div class="m-r-2 m-r-3-s">
                        <item-qty class="item-qty"
                                  [model]="data.qty"
                                  [product]="product"
                                  [max]="maxQty"
                                  [min]="localProduct.minQty"
                                  [status]="status"
                                  (qtyChange)="setQty($event)"></item-qty>
                        <!-- stock change notice -->
                        <result [status]="status"></result>
                        <!-- stock info -->
                        @if (!item.isInStock && item.maxQty) {
                        <div class="m-t-1 ta-center fs-4 fs-3-s">
                            {{'only % available' | translate : item.maxQty}}
                        </div>
                        }
                    </div>
                    }
                    <!-- remove -->
                    @if(item.productCanBeRemoved){
                    <action class="cursor-pointer"
                            [status]="removeStatus"
                            (click)="remove()"
                            cy-basketRemove>
                        <span class="c1 underline">{{'Remove' | translate}}</span>
                    </action>
                    }
                    <!-- add to wishlist -->
                    <!-- <wishlist-toggle class="m-l-2 z-1 basket-wishlist"
              [productId]="product.id"
            [parentId]="product.parent.id"></wishlist-toggle> -->
                    <div class="w-7 w-12-s">
                        <result class="block col-2 c1"
                                [status]="removeStatus"></result>
                    </div>
                </div>
            </div>
        </div>
    </div>
    @if (product?.isBundle && item.bundleSelection?.selection) {
    <div class="m-t p-l-14 p-l-5-s">
        <basket-bundle-options [product]="product"
                               [selection]="item.bundleSelection?.selection">
        </basket-bundle-options>
    </div>
    }
</div>
}
